import { render, staticRenderFns } from "./NoMfaSetting.vue?vue&type=template&id=0fa90920"
import script from "./NoMfaSetting.vue?vue&type=script&lang=js"
export * from "./NoMfaSetting.vue?vue&type=script&lang=js"
import style0 from "./NoMfaSetting.vue?vue&type=style&index=0&id=0fa90920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
